/**
 * Leaderboard API Service
 */

import { httpClient, HttpMethod } from './httpClient';
import {
  EmailReportingLeaderboardResponse,
  TrainingCompletionLeaderboardResponse,
  BadgeAchievementLeaderboardResponse,
  HighlightsResponse,
  LeaderboardFilters
} from '../types/leaderboard';

/**
 * Build query string from filters
 */
const buildQueryString = (filters: LeaderboardFilters): string => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value.toString());
    }
  });
  return params.toString();
};

/**
 * Get email reporting leaderboard
 */
export const getEmailReportingLeaderboard = (
  filters: LeaderboardFilters
): Promise<EmailReportingLeaderboardResponse> => {
  const queryString = buildQueryString(filters);
  return httpClient(
    `/learner/leaderboard/email-reporting?${queryString}`,
    HttpMethod.Get,
    null
  ) as Promise<EmailReportingLeaderboardResponse>;
};

/**
 * Get training completion leaderboard
 */
export const getTrainingCompletionLeaderboard = (
  filters: LeaderboardFilters
): Promise<TrainingCompletionLeaderboardResponse> => {
  const queryString = buildQueryString(filters);
  return httpClient(
    `/learner/leaderboard/training-completion?${queryString}`,
    HttpMethod.Get,
    null
  ) as Promise<TrainingCompletionLeaderboardResponse>;
};

/**
 * Get badge achievement leaderboard
 */
export const getBadgeAchievementLeaderboard = (
  filters: LeaderboardFilters
): Promise<BadgeAchievementLeaderboardResponse> => {
  const queryString = buildQueryString(filters);
  return httpClient(
    `/learner/leaderboard/badge-achievement?${queryString}`,
    HttpMethod.Get,
    null
  ) as Promise<BadgeAchievementLeaderboardResponse>;
};

/**
 * Get leaderboard highlights
 */
export const getLeaderboardHighlights = (
  cellId: number
): Promise<HighlightsResponse> => {
  return httpClient(
    `/learner/leaderboard/highlights?cell_id=${cellId}`,
    HttpMethod.Get,
    null
  ) as Promise<HighlightsResponse>;
};
